import React from 'react';
import { Container } from 'react-bootstrap';
import { BsMouse } from 'react-icons/bs';

const TopSlider = () => {
    return (
        <div className='welcomeScreen'>
            <Container>
                <div className='welcome-screen-content'>
                    <h2>Welcome to ShipShop</h2>
                    <p>
                        Here's my MERN project which is basically an E-commerce (Clothing) Project!
                    </p>
                    <a className='primary-btn d-flex align-items-center' href='#featuredProducts'>
                        Scroll <BsMouse className='ms-2' />
                    </a>
                </div>
            </Container>
        </div>
    );
};

export default TopSlider;
